module.exports = {
	...require('../src/global/environment')
};
